import { render, staticRenderFns } from "./FPRecurringExpensesDetails.vue?vue&type=template&id=288cf35a"
import script from "./FPRecurringExpensesDetails.vue?vue&type=script&lang=js"
export * from "./FPRecurringExpensesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports